import { IQuantity, Quantity } from "../../../../common/models/quantity.model";

export const generateNew = (quantity: IQuantity, actions: any, selectedOrder?: any) => {
  const items = [{
    key: "delete",
    text: "Anuluj zamówienie",
    iconProps: { iconName: "delete" },
    name: "delete",
    onClick: actions.setOrderCanceled,
  },
  {
    key: "activate",
    text: "Akceptuj zamówienie",
    iconProps: { iconName: "followUser" },
    name: "activate",
    onClick: actions.setOrderAccepted,
  },]

  // Dodaj przycisk zarządzania rozbiciami CUO tylko dla zamówień z CUO i statusem Accepted
  const cuoSplitsButton = selectedOrder && selectedOrder.isFromCuo === "CUO" && selectedOrder.currentStatus === 1 ? [{
    key: "cuoSplits",
    text: "Zarządzaj rozbiciami",
    iconProps: { iconName: "BranchMerge" },
    name: "cuoSplits",
    onClick: actions.openCuoSplitsPanel,
  }] : [];

  switch (quantity) {
    case Quantity.NONE:
      return [
        {
          key: "add",
          text: "Dodaj",
          iconProps: { iconName: "add" },
          onClick: actions.addNewOrder,
        },
      ];
    case Quantity.ONE:
      return [
        {
          key: "see",
          text: "Zobacz",
          iconProps: { iconName: "textDocument" },
          onClick: actions.openPanelToSee,
        },
        {
          key: "add",
          text: "Edytuj",
          iconProps: { iconName: "edit" },
          onClick: actions.openPanel,
        },
        ...cuoSplitsButton,
        ...items
      ];
    case Quantity.MANY:
      return [
        ...items
      ];
  }
};
